import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { styleInsidePopover } from '../../../Components/helper';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { SortIcon, SortDownIcon } from '../../../bombiix-icon';

function BtnSortNew({ onBtnClick, options, val }) {
  const { t } = useTranslation('common');
  const isDescending = val?.value?.sortOrder === 'Desc';

  return (
    <CustomTooltip placement="top" tooltipText={t('FILTER.SORT')}>
      <button type="button" aria-label={t('FILTER.SORT')} className={val ? 'bombiix-icon-container active' : 'bombiix-icon-container'}>
        <OverlayTrigger
          placement={t('TAKING_DATES.BUTTON')}
          trigger="click"
          rootClose
          overlay={
            <Popover className="custom-popover">
              <Popover.Content>
                <Select
                  isClearable
                  options={options}
                  value={val}
                  classNamePrefix="common-select"
                  onChange={onBtnClick}
                  styles={styleInsidePopover}
                  placeholder={t('FILTER.SORT_BY')}
                />
              </Popover.Content>
            </Popover>
          }
        >
          <span className="d-inline-flex">{isDescending ? <SortDownIcon size={28} /> : <SortIcon size={28} />}</span>
        </OverlayTrigger>
      </button>
    </CustomTooltip>
  );
}

export default BtnSortNew;
